// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/praktikum-bei-der-dietz-gmbh/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const praktikumBeiDerDietzGmbhDE: PageEntry = {
  id: "post.praktikum-bei-der-dietz-gmbh",
  locale: "de",
  slug: "praktikum-bei-der-dietz-gmbh",
  seo: {
    title: "Praktikum bei der Dietz GmbH | Starte mit uns durch | Dietz GmbH",
    description: "Praktikum bei der Dietz GmbH | Starte mit uns durch",
  },
  type: "post",
  h1: "Praktikum bei der Dietz GmbH | Starte mit uns durch",
  blocks: [
    { kind: "heading", level: 2, text: "Praktikum bei der Dietz GmbH | Starte mit uns durch" },
    { kind: "paragraph", text: "Du suchst noch eine freie Praktikumsstelle für dein anstehendes Praktikum? Dann bist du bei uns genau richtig. Egal ob Schulpraktikum oder freiwilliges Praktikum während den Ferien – wir geben dir die Chance." },
    { kind: "paragraph", text: "➡️ Wir bieten dir sogar die Möglichkeit gleich mehrere Berufsfelder kennenzulernen. Das klingt spannend?" },
    { kind: "paragraph", text: "Dann melde dich rechtzeitig bei uns: ruf gerne bei uns durch (+49 (0) 9568 9442-0) oder schreibe uns eine E-Mail (karriere@dietz.eu)." },
    { kind: "paragraph", text: "Wir freuen uns auf dich!" }
  ],
};
